export default {
  getInterviewQuestion: (state) => state.interviewQuestion,
};
